
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "f5e8e841-1d2a-4228-8c95-05aecbecab19"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/builds/sites/wnhub-general-client/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
